<template>
  <v-card class="assign-color">
    <slot></slot>
  </v-card>
</template>

<script>
export default {}
</script>

<style scoped>
  .assign-color {
    background-color: var(--v-primary-base);
  }

  .assign-color:hover {
    z-index: 3;
    background: var(--v-sixth-base);
    transform: scale(1.1, 1.2);
  }
</style>